



































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { BankCustodian } from "@/admin/types";
import * as elements from "@/shared/elementsUrls";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({})
export default class DisclosureLinks extends Vue {

  custodianSettingsStore = useCustodianSettingsStore();
  featureFlags = useFeatureFlagStore();

  ElementsUrls = elements;

  open (url) {
    openUrl(url, AppBrowserTarget.system);
  }

  get showElementsFeeSchedule () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.Elements;
  }

  get showDripDisclosure () {
    return this.featureFlags.flags.bend18128EnableDrivewealthDividendReinvestment;
  }

  get isMobile () {
    return isMobileApp();
  }
}
